import React, { useCallback, useEffect, useMemo, useState } from 'react';
import EmailSuccessToast from './EmailSuccessToast';

export const appFeedbackEventName = 'unified-workforce:feedback';

const emitFeedback = (type, message, options = {}) => {
  if (typeof window === 'undefined' || !message) return;
  window.dispatchEvent(new CustomEvent(appFeedbackEventName, {
    detail: {
      id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      type,
      message,
      submessage: options.submessage || '',
      duration: options.duration ?? 6000,
      actionLabel: options.actionLabel || '',
      onAction: options.onAction,
    },
  }));
};

export const notifySuccess = (message, options) => emitFeedback('success', message, options);
export const notifyError = (message, options) => emitFeedback('error', message, options);
export const notifyInfo = (message, options) => emitFeedback('info', message, options);
export const notifyWarning = (message, options) => emitFeedback('warning', message, options);

const AppFeedbackCenter = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const handleFeedback = (event) => {
      const item = event.detail;
      if (!item?.message) return;
      setItems((current) => {
        const duplicate = current.some((entry) => (
          entry.message === item.message && entry.type === item.type
        ));
        return duplicate ? current : [...current, item];
      });
    };
    window.addEventListener(appFeedbackEventName, handleFeedback);
    return () => window.removeEventListener(appFeedbackEventName, handleFeedback);
  }, []);

  const current = items[0] || null;
  const closeCurrent = useCallback(() => setItems((queue) => queue.slice(1)), []);

  const action = useMemo(() => {
    if (!current?.actionLabel || typeof current.onAction !== 'function') return null;
    return {
      label: current.actionLabel,
      run: () => {
        current.onAction();
        closeCurrent();
      },
    };
  }, [closeCurrent, current]);

  return (
    <EmailSuccessToast
      visible={Boolean(current)}
      message={current?.message}
      submessage={current?.submessage}
      duration={current?.duration}
      tone={current?.type}
      isError={current?.type === 'error'}
      actionLabel={action?.label}
      onAction={action?.run}
      onClose={closeCurrent}
    />
  );
};

export default AppFeedbackCenter;
